export function spongeCase(input) {
    var result = "";
    for (var i = 0; i < input.length; i++) {
        result +=
            Math.random() > 0.5 ? input[i].toUpperCase() : input[i].toLowerCase();
    }
    return result;
}
//# sourceMappingURL=index.js.map